<template>
  <div id="approve_order">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.details')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row class="approve_order_bg">
      <van-col span="24" v-if="isLocalCurrencyShow">
        <!-- 提现成功标题和金额  === '0'-->
        <van-col span="24" class="withdraw-success-header">
          <van-col span="24" class="withdraw-amount">${{ orderData.dollar_amount }}</van-col>
          <van-col span="24" :class="orderData.result_status == 0 ? 'withdraw-wait-text' : orderData.result_status == 1 ? 'withdraw-success-text' : 'withdraw-success-text'"> {{ orderData.result_text }}</van-col>
        </van-col>

        <!-- 详细信息卡片 -->
        <van-col span="22" offset="1" class="withdraw-info-card">
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.Platform_id') }}:</van-col>
            <van-col span="12" class="info-value">{{ orderData.user_id }}</van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.amount_details') }}:</van-col>
            <van-col span="12" class="info-value">${{ orderData.dollar_amount }} = <img src="../assets/img/coin9.png" class="info-value-img"/>{{ orderData.bean_amount }}</van-col>
          </van-col>
          <van-col span="24" class="info-row"  v-if="orderData.user_currency_code">
            <van-col span="12" class="info-label">{{ $t('column.local_currency') }}:</van-col>
            <van-col span="12" class="info-value">
              <img :src="orderData.user_country_img" class="info-value-img" v-if="orderData.user_country_img"/>
              <span> {{ orderData.user_currency_code }} {{ orderData.user_local_amount }}</span>
            </van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.actual_amount_received') }}:</van-col>
            <van-col span="12" class="info-value">
              <span v-if="orderData.user_currency_code">{{ orderData.user_currency_code }} {{ orderData.user_local_amount }}</span>
              <span v-else>${{ orderData.dollar_amount }}</span>
             </van-col>
          </van-col>
        </van-col>

        <!-- 支付方式和钱包地址卡片 -->
        <van-col span="22" offset="1" class="withdraw-info-card">
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.payment_method') }}:</van-col>
            <van-col span="12" class="info-value">
              <img :src="orderData.payment_method_img" class="payment-icon" /> {{ orderData.payment_method_name }}
            </van-col>
          </van-col>
          <van-col span="24" class="info-row" v-for="(t,i) in orderData.account_json" :key="i">
            <van-col span="12" class="info-label">{{ t.name }}</van-col>
            <van-col span="12" class="info-value address-value">
              <span  :id="'bkash_id' + i">{{ t.value }}</span>
              <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('bkash_id' + i)" />
            </van-col>
          </van-col>
        </van-col>
        <!-- 订单信息卡片 -->
        <van-col span="22" offset="1" class="withdraw-info-card">
          <van-col span="24" class="info-row">
            <van-col span="8" class="info-label">{{ $t('column.order_number') }}:</van-col>
            <van-col span="16" class="info-value">
              <span :id="'order_id' + orderData.order_id">{{ orderData.order_id }}</span>
               <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('order_id' + orderData.order_id)" />

            </van-col>
          </van-col>
          <van-col span="24" class="info-row">
            <van-col span="12" class="info-label">{{ $t('column.order_time') }}:</van-col>
            <van-col span="12" class="info-value">{{ orderData.create_time }}</van-col>
          </van-col>
          <van-col span="24" class="info-row" v-if="orderData.process_time">
            <van-col span="12" class="info-label">{{ $t('column.payment_time') }}:</van-col>
            <van-col span="12" class="info-value">{{ orderData.process_time }}</van-col>
          </van-col>
        </van-col>
        
          <!-- 支付凭证 -->
          <van-col span="22" offset="1" class="approve_order_bg_proof" v-if="orderData.seller_uid && orderData.payment_proofs_img">
            <van-col span="22" offset="1" class="approve_order_bg_proof_title">{{ $t('column.payment_proof')}}</van-col>
            <van-col span="22" offset="1">
              <img :src="orderData.payment_proofs_img" class="approve_order_bg_proof_img" @click="showImg(orderData.payment_proofs_img)"/>
            </van-col>
          </van-col>
          <!-- 倒计时提醒 -->
          <van-col span="22" offset="1" v-if="countdown_time && orderData.seller_uid && orderData.is_submit == 2">
            <van-col span="22" offset="1" class="approve_order_bg_content">
              <van-count-down :time="countdown_time" style="display: inline-block; color: #FF6666; vertical-align: baseline;" />
              <span style="margin-left: 2px;">{{ $t('column.payment_will_automatically_confirmed') }}</span>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="approve_order_bg_button" v-if="orderData.is_submit == 2 && orderData.seller_uid">
            <van-button color="#FF61F5" round block @click="ConfirmationPaymentButton">{{ $t('column.confirmation_of_payment')}}</van-button>
          </van-col>
      </van-col>
      <van-col span="24" v-else>
        <!-- 订单状态 -->
        <van-col span="22" offset="1" class="approve_order_status">
          <van-tag type="warning" round  :color="shouldShowColor(orderData.status)">
            <img src="../assets/img/approve_order_status.png" v-if="orderData.status ==='0'"/>
            <img src="../assets/img/approve_order_status1.png" v-else-if="orderData.status ==='1'"/>
            <img src="../assets/img/approve_order_status3.png" v-else-if="orderData.status ==='3'"/>
            <img src="../assets/img/approve_order_status4.png" v-else/>
            {{ orderData.status_text }}
          </van-tag>
        </van-col>
        <!-- 支付金额信息 -->
        <van-col span="22" offset="1">
          <van-col span="24" class="approve_order_payment_label">{{ $t('column.payment_amount')}}</van-col>
          <van-col span="18" class="approve_order_payment_money">
            {{ orderData.currency_type_code }}  <span id="payment_amount">{{ orderData.cash_amount }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('payment_amount')" />
          </van-col>
          <van-col span="6" class="approve_order_payment_img">
            <img :src="orderData.payment_method_img"/>
          </van-col>
          <van-col span="24" class="approve_order_id">{{ $t('column.order_id') }}:  <span id="creator_user_id">{{ orderData.order_id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('creator_user_id')" /></van-col>
          <van-col span="24" class="approve_order_create_time">{{ $t('column.order_create_time')}}: {{ orderData.create_time }}</van-col>
        </van-col>

        <van-col span="24" class="approve_order_bg">
          <!-- 倒计时提醒 -->
          <van-col span="22" offset="1" class="approve_order_bg_time" v-if="countdown_time">
            <van-col span="24" class="approve_order_bg_time_icon">
              <van-icon name="clock" color="#ffffff" size="20" /> <van-count-down :time="countdown_time" />
            </van-col>
            <van-col span="22" offset="1" class="approve_order_bg_content"> {{ $t('column.payment_will_automatically_confirmed') }} </van-col>
          </van-col>
          <!--   详细信息     -->
          <van-col span="22" offset="1" class="approve_order_bg_bean" v-if="orderData.seller_uid === uid">
            <van-col span="22" offset="1" class="approve_order_bg_bean_title">{{ ticket_name }} {{ $t('column.details')}}</van-col>
            <van-col span="22" offset="1" class="approve_order_bg_bean_rewards">
              <van-col span="8" class="approve_order_bg_bean_rewards_item">
                <van-col span="24" class="approve_order_bg_bean_rewards_item_label">{{ $t('column.total') }}</van-col>
                <van-col span="24" class="approve_order_bg_bean_rewards_item_value">
                  <img src="../assets/img/coin9.png"/> {{ orderData.total_amount }}
                </van-col>
              </van-col>
              <van-col span="8" class="approve_order_bg_bean_rewards_item">
                <van-col span="24" class="approve_order_bg_bean_rewards_item_label">{{ $t('other.profit')}}</van-col>
                <van-col span="24" class="approve_order_bg_bean_rewards_item_value">
                  <img src="../assets/img/coin9.png"/> {{ orderData.received_amount }}
                </van-col>
              </van-col>
              <van-col span="8" class="approve_order_bg_bean_rewards_item">
                <van-col span="24" class="approve_order_bg_bean_rewards_item_label">{{ $t('column.official_reward')}}</van-col>
                <van-col span="24" class="approve_order_bg_bean_rewards_item_value">
                  <img src="../assets/img/coin9.png"/> {{ orderData.official_amount }}
                </van-col>
              </van-col>
            </van-col>
          </van-col>
          <!-- 账户信息 -->
          <van-col span="22" offset="1" class="approve_order_bg_account">
            <van-col span="22" offset="1" v-for="(t,i) in orderData.account_json" :key="i">
              <van-col span="12" class="approve_order_bg_account_info_label">{{ t.name }}</van-col>
              <van-col span="12" class="approve_order_bg_account_info_value">
                <span :id="'bkash_id' + i">{{ t.value }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId('bkash_id' + i)" />
              </van-col>
            </van-col>
          </van-col>



          <!-- 支付凭证 -->
          <van-col span="22" offset="1" class="approve_order_bg_proof">
            <van-col span="22" offset="1" class="approve_order_bg_proof_title">{{ $t('column.payment_proof')}}</van-col>
            <van-col span="22" offset="1">
              <img :src="orderData.payment_proofs_img" class="approve_order_bg_proof_img" @click="showImg(orderData.payment_proofs_img)"/>
            </van-col>
          </van-col>

          <van-col span="22" offset="1" class="approve_order_bg_button" v-if="orderData.is_submit === 2">
            <van-button color="#FF61F5" round block @click="ConfirmationPaymentButton">{{ $t('column.confirmation_of_payment')}}</van-button>
          </van-col>
        
        </van-col>
      </van-col>
        <van-col span="22" offset="1" class="approve_order_bg_button" v-if="uid != orderData.seller_uid && orderData.status > 0">
          <van-button class="approve_order_bg_button_color" color="#ffffff" round block @click="OrderExceptionButton"><van-icon name="service-o" size="16" /> {{ $t('column.do_not_received')}}</van-button>
        </van-col>
    </van-row>
   
   

  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import UploadImage from "./upload_image.vue";
import axios from "axios";
import { Dialog,ImagePreview } from "vant";
export default {
  components: {
    UploadImage
  },
  data() {
    return {
      countdown_time: 0,
      ticket_name: '',
      orderId: undefined,
      orderData: {},
      uid: this.$route.query.uid,
      isLocalCurrencyShow: true
    }
  },
  created() {
    this.orderId = this.$route.query.order_id
    this.get_info()
  },
  methods: {
    shouldShowColor(status){
      switch ( status) {
        case '0':
          return '#FFF0FD'
        case '1':
          return '#FFF7E2'
        case '3':
          return '#F1FFF6'
        default:
          return '#e0e0e0'
      }
    },
    showImg(img) {
      ImagePreview([img])
    },
    get_info(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_order_info",{
        params:{
          uid: uid,
          token: token,
          order_id: this.orderId
        }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status ===1){
          this.orderData = res.data.data
          this.countdown_time = res.data.data.countdown_time * 1000
          this.ticket_name = res.data.data.ticket_name
        }else{
          Toast(res.data.error)
        }
      })
    },
    OrderExceptionButton() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/feedback_order', query: { uid: uid, token: token, order_id: this.orderId } });
    },
    ConfirmationPaymentButton() {
      Dialog.confirm({
        title: this.$t('column.sure_payment_has_been_made2'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=confirm_payment_success",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.onClickLeft()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    copyId(id) {
      const element = document.getElementById(id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/withdraw_payroll_order.vue